import {useState} from 'react';
import {getUserInfoService, loginService} from '../services/authService';
import {useAuthContext} from "../context/AuthProvider";
import {Bounce, toast} from "react-toastify";

const useLoginForm = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {setRole} = useAuthContext()

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!username || !password) {
            return 'Ambos campos son requeridos';
        }

        setIsSubmitting(true);

        try {
            const response = await loginService(username, password);
            console.log(response.data.message);
        } catch (error: any) {
            console.error('Login Error:', error);
            setIsSubmitting(false);
            toast.error(error.message, {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: "colored",
                transition: Bounce,
            })
            return
        }

        try {
            const response = await getUserInfoService();
            const userRole = response.data.data.role.toLowerCase().replace(/_/g, '');
            setRole(userRole);
        } catch (error: any) {
            console.error('Error when getting user role:', error);
            toast.error(error.message, {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: "colored",
                transition: Bounce,
            })
            return
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        username,
        setUsername,
        password,
        setPassword,
        isSubmitting,
        handleSubmit,
    };
};

export default useLoginForm;

